import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import PageWrapper from "@modules/Layout/PageWrapper";
import HeadSeo from "@modules/seo/components/HeadSeo";
import CompanyHistory from "@modules/CompanyHistory/components";

import "@graphql/seoFragments";
import "@graphql/shared/bannerFragment";
import { ContentPage } from "@types/common";

interface IProps {
  location: any;
}

interface CompanyHistoryPageQueryData {
  strapiCompanyHistoryPage: ContentPage;
}

const CompanyHistoryPage: React.FC<IProps> = props => {
  const { location } = props;

  const data = useStaticQuery<CompanyHistoryPageQueryData>(graphql`
    query {
      strapiCompanyHistoryPage {
        id
        content {
          data {
            content
          }
        }
        banner {
          ...BannerFields
        }
        seo {
          ...SeoFields
        }
      }
    }
  `);

  const { metaTitle, metaDescription, keywords, meta_image } =
    data.strapiCompanyHistoryPage.seo;

  return (
    <PageWrapper>
      <HeadSeo
        title={metaTitle}
        description={metaDescription}
        pathname={location.pathname}
        keywords={keywords}
        image={meta_image.formats.small.url}
      />
      <CompanyHistory data={data.strapiCompanyHistoryPage} />
    </PageWrapper>
  );
};

export default CompanyHistoryPage;
